// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"4632f72b","363":"ce520f6b"}[chunkId] + ".chunk.js";
};